export class ChangelogView {
	constructor(state, options = {}) {
		this.state = state;
		this.options = options;
		this.element = null;
		this._unsubscribe = null;

		// Configurable header colour — defaults to Product7 blue
		this._headerBg = `linear-gradient(180deg, #f0f4ff 0%, #ffffff 100%)`;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = 'liveChat-view liveChat-changelog-view';

		this._updateContent();

		this._unsubscribe = this.state.subscribe((type) => {
			if (type === 'changelogUpdate') {
				this._updateChangelogList();
			}
		});

		return this.element;
	}

	_updateContent() {
		this.element.innerHTML = `
			<div class="liveChat-changelog-header">
				<div class="liveChat-changelog-header-top">
					<h2>Latest Updates</h2>
					<button class="sdk-close-btn liveChat-changelog-close-btn liveChat-mobile-close-btn" aria-label="Close">
						<iconify-icon icon="ph:x" width="18" height="18"></iconify-icon>
					</button>
				</div>
			</div>

			<div class="liveChat-changelog-body">
				<div class="liveChat-changelog-list"></div>
			</div>
		`;

		this._updateChangelogList();
		this._attachEvents();
	}

	_updateChangelogList() {
		const changelogContainer = this.element.querySelector(
			'.liveChat-changelog-list'
		);
		const changelogItems = this.state.changelogItems;

		if (changelogItems.length === 0) {
			changelogContainer.innerHTML = this._renderEmptyState();
			return;
		}

		changelogContainer.innerHTML = changelogItems
			.map((item) => this._renderChangelogCard(item))
			.join('');

		this._attachChangelogEvents();
	}

	_stripHtml(html) {
		if (!html) return '';
		const tmp = document.createElement('div');
		tmp.innerHTML = html;
		return (tmp.textContent || tmp.innerText || '').trim();
	}

	_renderChangelogCard(item) {
		return `
			<div class="liveChat-changelog-card" role="button" tabindex="0" data-changelog-id="${item.id}">
				${item.coverImage ? `<div class="liveChat-changelog-thumb"><img src="${item.coverImage}" alt="${item.title}" onerror="this.parentElement.style.display='none';" /></div>` : ''}
				<div class="liveChat-changelog-content">
					<h3 class="liveChat-changelog-title">${item.title}</h3>
					${item.description ? `<p class="liveChat-changelog-description">${this._stripHtml(item.description)}</p>` : ''}
				</div>
			</div>
		`;
	}

	_getContrastColor(hexColor) {
		const hex = hexColor.replace('#', '');
		const r = parseInt(hex.substring(0, 2), 16);
		const g = parseInt(hex.substring(2, 4), 16);
		const b = parseInt(hex.substring(4, 6), 16);
		const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
		return luminance > 0.5 ? '#374151' : '#ffffff';
	}

	_renderEmptyState() {
		return `
			<div class="liveChat-empty-state">
				<div class="liveChat-empty-state-icon">
					<iconify-icon icon="ph:megaphone" width="48" height="48"></iconify-icon>
				</div>
				<h3>No changelog yet</h3>
				<p>Check back later for updates</p>
			</div>
		`;
	}

	_formatDate(dateString) {
		if (!dateString) return '';
		const date = new Date(dateString);
		return date.toLocaleDateString('en-US', {
			month: 'short',
			day: 'numeric',
			year: 'numeric',
		});
	}

	_truncateText(text, maxLength) {
		if (!text) return '';
		if (text.length <= maxLength) return text;
		return text.substring(0, maxLength).trim() + '...';
	}

	_attachEvents() {
		const mobileCloseBtn = this.element.querySelector(
			'.liveChat-changelog-close-btn'
		);
		if (mobileCloseBtn) {
			mobileCloseBtn.addEventListener('click', () => {
				this.state.setOpen(false);
			});
		}

		this._attachChangelogEvents();
	}

	_attachChangelogEvents() {
		this.element
			.querySelectorAll('.liveChat-changelog-card')
			.forEach((card) => {
				card.addEventListener('click', () => {
					const changelogId = card.dataset.changelogId;
					const changelogItem = this.state.changelogItems.find(
						(n) => n.id === changelogId
					);
					if (changelogItem?.url) {
						window.open(changelogItem.url, '_blank');
					} else if (this.options.onChangelogClick) {
						this.options.onChangelogClick(changelogItem);
					}
				});
			});
	}

	destroy() {
		if (this._unsubscribe) {
			this._unsubscribe();
		}
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
